export default __webpack_public_path__ + "static/media/4682ba3bc6dc4eb89240caba148bc47a.2611d9bc.jpeg";